var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcDownloadPdf = function SvgIcDownloadPdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 64,
    viewBox: "16 8 44 88"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 10)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M4,1 L28,1 C29.6568542,1 31,2.34314575 31,4 L31,40 C31,41.6568542 29.6568542,43 28,43 L4,43 C2.34314575,43 1,41.6568542 1,40 L1,4 C1,2.34314575 2.34314575,1 4,1 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#AAB5C4",
    points: "23 31 23 42 15 42"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5B718D",
    fillRule: "nonzero",
    d: "M29,0 C30.6568542,0 32,1.34314575 32,3 L32,41 C32,42.6568542 30.6568542,44 29,44 L3,44 C1.34314575,44 0,42.6568542 0,41 L0,3 C0,1.34314575 1.34314575,0 3,0 L29,0 Z M29,2 L3,2 C2.48716416,2 2.06449284,2.38604019 2.00672773,2.88337887 L2,3 L2,41 C2,41.5128358 2.38604019,41.9355072 2.88337887,41.9932723 L3,42 L29,42 C29.5128358,42 29.9355072,41.6139598 29.9932723,41.1166211 L30,41 L30,3 C30,2.48716416 29.6139598,2.06449284 29.1166211,2.00672773 L29,2 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 2,
    x: 5,
    y: 5,
    fill: "#AAB5C4",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 2,
    x: 23,
    y: 5,
    fill: "#AAB5C4",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 2,
    x: 5,
    y: 37,
    fill: "#AAB5C4",
    rx: 1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 27)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 10,
    x: 9,
    y: 5,
    fill: "#5B718D",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 6,
    x: 7.586,
    y: 9.586,
    fill: "#5B718D",
    rx: 1,
    transform: "rotate(-45 8.586 12.586)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 6,
    x: 10.414,
    y: 9.586,
    fill: "#5B718D",
    rx: 1,
    transform: "rotate(45 11.414 12.586)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9,
    stroke: "#5B718D",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#D9534F",
    d: "M31.6977373,31.1085515 C31.2453475,32.1835192 30.7904412,33.2647368 30.3198434,34.3827265 C31.4509658,34.0982873 32.5319049,33.8264932 33.6011493,33.5578966 C32.9600171,32.732776 32.3350206,31.9287303 31.6977373,31.1085515 M30.8064288,27.0165231 C31.1901311,25.7108937 31.5827154,24.4054096 31.5180248,23.0247824 C31.491823,22.4682584 31.2641478,22.1384718 30.9159735,22.1155074 C30.5476666,22.0913802 30.291273,22.3531456 30.1879457,22.9210065 C29.9291835,24.3446556 30.3011912,25.6832782 30.8064288,27.0165231 M26.3639498,37.0688377 C25.0677703,37.625071 23.8185173,38.2352271 22.780952,39.1805476 C22.5688203,39.3738558 22.3928087,39.6149822 22.2392982,39.8579982 C22.0974823,40.0822647 22.069652,40.3332746 22.269645,40.5623375 C22.4675655,40.7893656 22.7282521,40.811458 22.9744315,40.7124784 C23.2426678,40.6046328 23.5094238,40.4629219 23.7331021,40.2835668 C24.8387628,39.3968202 25.6288164,38.2545579 26.3639498,37.0688377 M36.1024678,34.2692124 C37.0152411,34.9674473 37.9089181,35.4810947 38.9287194,35.7447495 C39.3010231,35.8412583 39.7013052,35.9007042 40.082787,35.8781758 C40.6651499,35.8440198 40.9994091,35.406969 40.9080726,34.9029143 C40.8307992,34.4754562 40.4888423,34.3151413 40.1232,34.2426144 C38.8218394,33.9846279 37.5197386,34.0952351 36.1024678,34.2692124 M33.306415,24.4504664 C33.261857,25.980217 32.834781,27.5387458 32.3751376,29.093205 C32.3274709,29.253956 32.3468632,29.4824375 32.4312422,29.6245844 C33.1635629,30.8592857 34.0233403,32.002856 35.0378124,33.0318949 C35.2016853,33.198169 35.3476461,33.2690971 35.609813,33.233633 C37.2936917,33.0054422 38.9894131,32.8223082 40.6672224,33.2209881 C41.2375947,33.3564491 41.8055984,33.6135635 42.2957366,33.9320132 C42.9282829,34.3427567 43.1000015,35.0151203 42.9482674,35.7300698 C42.8079318,36.3915325 42.3500648,36.7974796 41.6991625,36.9823578 C40.7067473,37.264326 39.7245464,37.1275569 38.7541882,36.8660822 C37.4161153,36.5057732 36.2405829,35.8389328 35.1831811,34.9700635 C34.9432191,34.772831 34.7288669,34.7071353 34.4190333,34.7898363 C32.8449953,35.2103179 31.2625194,35.6017306 29.6902578,36.0290433 C29.4950019,36.0822394 29.2858309,36.2557807 29.1799871,36.4300487 C28.2898629,37.8951211 27.3508877,39.3234212 26.093937,40.5188795 C25.3990688,41.1797609 24.6399541,41.7514007 23.6590855,41.9441275 C23.1158033,42.0508103 22.5822913,42.0099685 22.073945,41.7761092 C21.0652461,41.3115883 20.7170718,40.2860377 21.2445145,39.320369 C21.5900242,38.6878298 22.1233881,38.2235996 22.6980533,37.8028273 C23.9483425,36.8875932 25.3450366,36.2365952 26.7676365,35.6294914 C26.9411316,35.555511 27.12114,35.4066783 27.2107002,35.2456366 C28.379275,33.1445369 29.2674747,30.9245454 30.0539756,28.6640027 C30.1023825,28.5249081 30.0712955,28.3310185 30.0122302,28.188581 C29.4529604,26.8396389 29.0122653,25.458721 28.9869516,23.9923406 C28.9770334,23.4222996 29.0566753,22.8340905 29.2042645,22.2822175 C29.393303,21.5754073 29.9059423,21.1184443 30.6640208,21.0214995 C31.4848654,20.9165608 32.1695194,21.1953315 32.6531441,21.8675497 C33.1872482,22.609824 33.3067111,23.4654669 33.306415,24.4504664"
  }))));
};
export default SvgIcDownloadPdf;